"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emit = exports.visitorId = void 0;
const VisitorTracking_1 = require("./VisitorTracking");
exports.visitorId = VisitorTracking_1.getVisitorId();
var EventsToolkit_1 = require("./EventsToolkit");
Object.defineProperty(exports, "emit", { enumerable: true, get: function () { return EventsToolkit_1.emit; } });
